(function() {
  const header = document.querySelector('.header');
  const headerSection = document.querySelector('.headerSection');

  headerSection.style.marginTop = `${document.querySelector('.noticeList').scrollHeight}px`;

  function toggleHeaderModule() {
    if (window.pageYOffset < 1) {
      header.classList.add('header--split');
    } else {
      header.classList.remove('header--split');
    }
  }

  toggleHeaderModule();

  window.addEventListener('scroll', toggleHeaderModule);
}());
